import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiBookOpen,FiCheck,FiCheckCircle,FiHelpCircle,FiInfo}=FiIcons;

function renderBody(body) {
  return body.split('\n').map((line,index)=> {
    const formatted=line.replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>');

    if (line.trim().startsWith('- ')) {
      return (
        <li
          key={`${line}-${index}`}
          dangerouslySetInnerHTML={{__html: formatted.slice(2)}}
        />
      );
    }

    return (
      <p
        key={`${line}-${index}`}
        dangerouslySetInnerHTML={{__html: formatted}}
      />
    );
  });
}

function StudyAction({icon,label,onClick}) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        minHeight: '46px',
        padding: '11px 15px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        color: '#0f766e',
        fontSize: '0.8rem',
        fontWeight: 800,
        background: '#ffffff',
        border: '1px solid #b9d8d4',
        borderRadius: '9px',
        transition: 'background 0.2s,transform 0.2s',
      }}
      onMouseEnter={(event)=> {
        event.currentTarget.style.background='#ecfdf5';
        event.currentTarget.style.transform='translateY(-1px)';
      }}
      onMouseLeave={(event)=> {
        event.currentTarget.style.background='#ffffff';
        event.currentTarget.style.transform='translateY(0)';
      }}
    >
      <SafeIcon icon={icon} />
      {label}
    </button>
  );
}

function LessonContent({lesson,isCompleted,onToggle,onOpenTab}) {
  return (
    <div className="lesson-content-view">
      <div className="overview-callout">
        <SafeIcon icon={FiInfo} />
        <div>
          <span className="content-label">Lesson overview</span>
          <p>{lesson.overview}</p>
        </div>
      </div>

      <div className="content-sections">
        {lesson.contentSections.map((section)=> (
          <article className="instruction-section" key={section.heading}>
            <h2>{section.heading}</h2>
            <div className="instruction-body">
              {renderBody(section.body)}
            </div>
          </article>
        ))}
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          flexWrap: 'wrap',
        }}
      >
        <div style={{display: 'flex',gap: '9px',flexWrap: 'wrap'}}>
          <StudyAction
            icon={FiBookOpen}
            label="View Flashcards"
            onClick={()=> onOpenTab('flashcards')}
          />
          <StudyAction
            icon={FiHelpCircle}
            label="Take the Quiz"
            onClick={()=> onOpenTab('quiz')}
          />
        </div>

        <button
          className={isCompleted ? 'lesson-complete-cta is-complete' : 'lesson-complete-cta'}
          onClick={onToggle}
          aria-pressed={isCompleted}
        >
          <SafeIcon icon={isCompleted ? FiCheckCircle : FiCheck} />
          {isCompleted ? 'Lesson Completed' : 'Mark Lesson as Complete'}
        </button>
      </div>
    </div>
  );
}

export default LessonContent;